import React from 'react';
import { connect } from 'react-redux';
import schools from '../schools';

const mapStateToProps = (state) => {
  let school = schools[state.schedules.school] || {};
  return {
    schedules: state.schedules,
    schoolName: school.name
  }
};

export const ScheduleHeaderContainer = React.createClass({

  render: function() {
  
    if(!this.props.schedules.loading) {

      return (
        <div className="abl-schedule-builder-container">
          <div className="abl-navbar">
            <a href="#" className="abl-home" title="Home">
              <span></span>
              <span></span>
              <span></span>
            </a>
            <img className="abl-logo" src={require('../../../img/svg/logo.svg')} width="38" height="38" alt="Abl Schools" title="Abl Schools" />
            <div className="abl-school-name">{this.props.schoolName}</div>
            <img 
              className="abl-current-user-avatar" 
              src={require('../../../img/current_user_avatar_fpo.png')} 
              alt="Ann Marin"
              width="24" 
              height="24" />            
          </div>
        </div>
      );
    }
    else {
      return null;
    }
  }

});

export default connect(
  mapStateToProps
)(ScheduleHeaderContainer);


/** WEBPACK FOOTER **
 ** ./src/js/containers/schedule_header_container.js
 **/